module.exports = __webpack_public_path__ + "img/configusr.99da4861.svg";